<template>

    <div class="crud-scroller-main" ref="crudmainscroller">
        <slot></slot>
    </div>

</template>

<style lang="scss">
    div.crud-scroller-main {
        position:relative;
        overflow-y: scroll;
        overflow-x: hidden;
        -webkit-overflow-scrolling: touch;
        height: calc(100vh - 250px);
        max-height: calc(100vh - 250px);

        h2{
            margin: 5px 0 5px;
            font-size: 1.15em;
            color: #659dba;
            clear:both;
        }
        ul{
            margin-bottom:30px;
            a{
                color:$brand;
                text-decoration:none;
            }
        }

        @include mobile(){
            height: calc(100vh - 191px);
            max-height: calc(100vh - 191px);
        }
    }
</style>

<script>
    export default {
        data() {
            return {}
        },
        watch: {},
        computed: {
            name(){
                return this.$parent.name;
            }
        },
        methods: {

        },
        mounted() {}
    }
</script>
